import React from "react";
import { IconT } from "types/utils";

const PowurLogoFull = ({ height = "24", width = "auto", className }: IconT) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1163 334"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_powur_full)">
        <path d="M35.4028 85.4147V35.3813H85.467L35.4028 85.4147Z" fill="#20C2F1" />
        <path d="M35.4029 156.178L-0.000244141 120.796L35.4029 85.4148V156.178Z" fill="#20C2F1" />
        <path d="M85.4672 35.3814L120.87 0L156.273 35.3814H85.4672Z" fill="#20C2F1" />
        <path d="M156.273 206.239L120.87 241.62L85.4672 206.239H156.273Z" fill="#20C2F1" />
        <path d="M120.87 170.857V120.796H170.962L120.87 170.857Z" fill="#F4C751" />
        <path d="M120.87 70.7627V120.796H70.806L120.87 70.7627Z" fill="#F4C751" />
        <path d="M85.467 206.239H35.4028V156.177L85.467 206.239Z" fill="#20C2F1" />
        <path d="M206.365 156.177V206.239H156.273L206.365 156.177Z" fill="#20C2F1" />
        <path d="M206.365 85.4148L241.768 120.796L206.365 156.178V85.4148Z" fill="#20C2F1" />
        <path d="M156.273 35.3813H206.365V85.4147L156.273 35.3813Z" fill="#20C2F1" />
        <path
          d="M308.243 334V157.953H371.136C413.453 157.953 434.028 176.601 434.028 214.952V241.814C434.028 272.256 413.453 287.074 371.136 287.074H330.679V334.027H308.215L308.243 334ZM330.707 266.955H371.163C397.986 266.955 411.62 258.492 411.62 241.786V203.186C411.62 186.48 398.014 178.016 371.163 178.016H330.707V266.928V266.955Z"
          fill="#20C2F1"
        />
        <path
          d="M515.802 287.074C473.485 287.074 452.91 272.284 452.91 241.814V203.214C452.91 172.744 473.485 157.953 515.802 157.953C558.119 157.953 578.695 172.744 578.695 203.214V241.814C578.695 272.256 558.119 287.074 515.802 287.074ZM515.802 178.072C488.979 178.072 475.346 186.536 475.346 203.242V241.842C475.346 258.547 488.951 267.011 515.802 267.011C542.653 267.011 556.259 258.547 556.259 241.842V203.242C556.259 186.536 542.653 178.072 515.802 178.072Z"
          fill="#20C2F1"
        />
        <path
          d="M736.857 283.689L696.9 174.853L656.971 283.689H633.452L583.138 157.953H605.352L645.225 254.607L685.127 157.953H708.701L748.575 254.607L788.476 157.953H810.69L760.376 283.689H736.857Z"
          fill="#20C2F1"
        />
        <path
          d="M884.467 287.074C842.15 287.074 821.574 272.284 821.574 241.814V157.953H844.038V241.814C844.038 258.52 857.644 266.983 884.495 266.983C911.346 266.983 924.952 258.52 924.952 241.814V157.953H947.415V241.814C947.415 272.256 926.84 287.074 884.523 287.074H884.467Z"
          fill="#20C2F1"
        />
        <path
          d="M968.963 283.689V157.953H1031.86C1073.39 157.953 1093.97 172.217 1094.75 201.521H1072.26C1071.34 185.953 1057.79 178.044 1031.86 178.044H991.398V283.689H968.935H968.963Z"
          fill="#20C2F1"
        />
        <path
          d="M1163 179.071C1163 191.004 1153.61 200.355 1141.42 200.355C1129.23 200.355 1119.74 190.976 1119.74 179.071C1119.74 167.166 1129.37 158.037 1141.42 158.037C1153.48 158.037 1163 167.416 1163 179.071ZM1125.13 179.071C1125.13 188.451 1132.07 195.888 1141.56 195.888C1151.06 195.888 1157.61 188.451 1157.61 179.21C1157.61 169.969 1150.81 162.282 1141.42 162.282C1132.04 162.282 1125.13 169.858 1125.13 179.099V179.071ZM1138.09 190.116H1133.21V169.081C1135.12 168.693 1137.81 168.443 1141.29 168.443C1145.26 168.443 1147.06 169.081 1148.62 169.969C1149.78 170.857 1150.67 172.522 1150.67 174.576C1150.67 176.879 1148.87 178.683 1146.31 179.46V179.709C1148.37 180.486 1149.53 182.013 1150.17 184.843C1150.81 188.062 1151.2 189.339 1151.7 190.116H1146.42C1145.78 189.339 1145.4 187.424 1144.76 184.982C1144.37 182.679 1143.09 181.652 1140.4 181.652H1138.09V190.116ZM1138.23 178.183H1140.54C1143.23 178.183 1145.42 177.295 1145.42 175.103C1145.42 173.188 1144.01 171.884 1140.92 171.884C1139.65 171.884 1138.73 172.023 1138.23 172.134V178.155V178.183Z"
          fill="#20C2F1"
        />
      </g>
      <defs>
        <clipPath id="clip0_powur_full">
          <rect width="1163" height="334" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PowurLogoFull;
